import { render, staticRenderFns } from "./AddAPI.vue?vue&type=template&id=6c6bc670&"
import script from "./AddAPI.vue?vue&type=script&lang=js&"
export * from "./AddAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports